import haversine from 'haversine';
import Logger from './logger';
import { getResyConfigThunk } from '../reducers/resyConfigSlice';
import { getResyLocationsThunk } from '../reducers/resyLocationsSlice';

const DEFAULT_LAT_LNG_VALUE = '40.7643304, -73.9772046';

const getLatLng = () => (dispatch, getState) => dispatch(getResyConfigThunk())
  .then(() => dispatch(getResyLocationsThunk()))
  .then(() => {
    const { resyLocations: { selected: selectedLocation }, user: { userLocation } } = getState();
    let latLng = null;
    if (selectedLocation && 'hideMenu' in selectedLocation) {
      const { lat, long } = userLocation;
      latLng = {
        useIp: true,
        value: `${lat}, ${long}`,
      };
    } else {
      try {
        let lat = selectedLocation?.map_center.latitude;
        let long = selectedLocation?.map_center.longitude;
        if (lat && long && haversine && 'lat' in userLocation && 'long' in userLocation) { /* instabul ignore else */
          const isWithinRadius = haversine(
            { latitude: lat, longitude: long },
            { latitude: userLocation.lat, longitude: userLocation.long },
            {
              threshold: selectedLocation.radius,
              unit: 'mile',
            }
          );

          if (isWithinRadius) {
            ({ lat, long } = userLocation);
            latLng = {
              useIp: true,
              value: `${lat}, ${long}`,
            };
          } else {
            latLng = {
              useIp: false,
              value: `${lat}, ${long}`,
            };
          }
        } else {
          return { useIp: true, value: DEFAULT_LAT_LNG_VALUE };
        }
      } catch (e) {
        Logger.error(e);
        return { useIp: true, value: DEFAULT_LAT_LNG_VALUE };
      }
    }
    return latLng;
  });

export { DEFAULT_LAT_LNG_VALUE };
export default getLatLng;
